import React, { useEffect, useState } from "react";
import { showData } from "../../Utils/APIs/commonShowAPI";
const CommonDropdown = ({ Api_path, value, onChange, label }) => {
  const [ListData, setListData] = useState([]);
  useEffect(() =>{
    showData(Api_path, setListData);
  },[])
  return (
    <div>
      <select
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  block w-full p-2.5"
        id="state-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">-- Select {label} --</option>
        {ListData.length !== 0 && ListData.map(({name, index}) =>(
          <option key={index} value={name}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CommonDropdown;
